
<template>
  <!--秒杀详情-->
  <div class="advanced-form">
    <a-form layout="vertical">
      <div class="card">
        <div class="card-head">
          <h3>基础信息</h3>
        </div>
        <div class="card-body">
          <a-row type="flex">
            <a-col v-for="(item, index) of baseInfo" :key="index" :span="8">
                <a-form-item class="value-indent" :label="item.key == 'imgUrl'? '':item.label">
                  <div class="pic-box" v-if="item.key=='imgUrl'">
                    <img :src="item.value" alt="">
                  </div>
                  <span v-else-if="item.key=='title'" @click="toDetail()" class="ant-form-text"><a>{{item.value}}</a></span>
                  <span v-else-if="item.key=='seckillFee'" class="ant-form-text">{{item.value|toMoney}}</span>
                  <span v-else-if="item.key!='imgUrl'" class="ant-form-text">{{item.value}}</span>

                </a-form-item>
              </a-col>
          </a-row>
        </div>
      </div>
    </a-form>
  </div>
</template>

<script>
export default {
  name: 'limitedTimeDiscountDetail',
  data () {
    return {
      id: undefined,
      baseInfo: [
        {key: 'shopName', label: '店铺', value: ''},
        {key: 'title', label: '标题', value: ''},
        {key: 'imgUrl', label: '封面', value: ''},
        {key: 'createTime', label: '发布时间', value: ''},
        {key: 'endTimeDesc', label: '结束时间', value: ''},
        {key: 'temp', label: '', value: ''},
        {key: 'seckillFee', label: '秒杀价格', value: ''},
        {key: 'dailyCopies', label: '每日份数', value: ''},
        {key: 'activityDateDesc', label: '活动时间', value: ''},
        {key: 'isNewMemberDesc', label: '新客专享', value: ''}
      ]
    };
  },
  beforeRouteEnter (to, from, next) {
    next();
    setTimeout(() => {
      document.getElementsByClassName('layout-content')[0].style.padding = '0px';
      document.getElementsByClassName('layout-content')[0].style.backgroundColor = 'transparent';
    }, 0);
  },
  beforeRouteLeave (to, from, next) {
    document.getElementsByClassName('layout-content')[0].style.padding = '16px';
    document.getElementsByClassName('layout-content')[0].style.backgroundColor = '#fff';
    next();
  },
  filters: {
    toMoney (val) {
      if (val != null) {
        return '￥' + Number(val).toFixed(2);
      } else {
        return '';
      }
    }
  },
  created () {
    this.getDetail();
  },
  methods: {
    toDetail () {
      this.$router.push({
        name: 'goodsDetail',
        query: { id: this.id, parentTitle: '限时秒杀', parentPath: '/local/LimitedTimeSeckill'}
      });
    },
    getDetail () {
      this.$get({
        url: `/local/shop/seckill/${this.$route.query.id}`, //
        params: {}
      }).then(({data}) => {
        this.id = data.goodsId;
        for (let item in data) {
          this.baseInfo.forEach((el) => {
            if (el.key === item) {
              el.value = data[item];
            }
          });
        }
      });
    }
  }
};
</script>
<style scoped >
.pic-box{
  width:200px;
  height: 70px;
  max-height: 70px;
  overflow: hidden;
}
.pic-box img{
  height: 70px;
  width: auto !important;
  max-height: 70px;
}
  .card{
    margin-bottom:24px;
  }
</style>
